export const CHAT_FEATURE_FLAG = 'coachChatEnabled';
export const NEXT_SESSION_DATE_FEATURE_FLAG = 'nextSessionDateEnabled';
export const SPRINT_NUMBER_FEATURE_FLAG = 'coachedSprintNumberEnabled';
export const COACH_DASHBOARD_FEATURE_FLAG = 'coachDashboardEnabled';
